module.exports = __webpack_public_path__ + "img/result.f9d303fd.jpg";